module.exports = __webpack_public_path__ + "static/img/Booking.aa504ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage/Booking.png
// module id = 321u
// module chunks = 0